import React from 'react';

import { BaSeAccordion } from '@base/react';
import {
  ContentQuestions,
  FraseItem,
  FrasesContainer,
} from './accortion-informations-style';

const AccordionInformations = ({ currentFrases, activeQuestionId }) => {
  return (
    <ContentQuestions>
      <BaSeAccordion
        backgroundContentColor={'#215DF4'}
        backgroundTitleColor={'#215DF4'}
        clickableTitle={true}
        shadow="0"
        titleButtonIconSize="small"
        titleButtonSize="small"
        options={[
          {
            content: (
              <FrasesContainer>
                {currentFrases.map((frase, index) => (
                  <FraseItem key={index}>{frase}</FraseItem>
                ))}
              </FrasesContainer>
            ),
            title: (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <p>Dicas para Pergunta {activeQuestionId}</p>
              </div>
            ),
          },
        ]}
        radius={30}
        titleColor="#ffffff"
      />
    </ContentQuestions>
  );
};

export default AccordionInformations;
